import { Routes, Route } from 'react-router-dom';
import HomePage from 'src/pages/HomePage';
import ReportsPage from 'src/pages/ReportsPage';
import FeedbackExportPage from 'src/pages/FeedbackExportPage';
import SettingsPage from 'src/pages/SettingsPage';
import TasksPage from 'src/pages/tasks/TasksPage';
import UsersPage from 'src/pages/users/UsersPage';
import NotificationsPage from 'src/pages/NotificationsPage';
import LocationsPage from 'src/pages/locations/LocationsPage';
import TranslationsPage from 'src/pages/TranslationsPage';
import TeamsPage from 'src/pages/teams/TeamsPage';
import PermissionsPage from 'src/pages/PermissionsPage';
import TagsPage from 'src/pages/tags/TagsPage';
import QuestionsCategoryPage from './pages/question-categories/QuestionsCategoryPage';
import { TaskDetailsPage } from './pages/task-details/TaskDetailsPage';
import routes from './contstant/routePaths';
import SchedulesDetailsPage from './pages/schedule-details/SchedulesDetailsPage';
import SchedulesPage from './pages/schedules/SchedulesPage';
import TemplateDetailsPage from './pages/template-details/TemplateDetailsPage';
import TemplatesPage from './pages/templates/TemplatesPage';
import QuestionPage from './pages/questions/QuestionPage';
import QuestionDetailsPage from './pages/question-details/QuestionDetailsPage';
import { AuditsPageGate } from './pages/audits/AuditsPageGate';
import PerformAuditPage from './pages/perform-audit/PerformAuditPage';
import AuditSummaryPage from './pages/audit-summary/AuditSummaryPage';
import AddEditQuestionPage from './pages/question-details/AddEditQuestionPage';
import TranslationEditPage from './pages/question-details/TranslationEditPage';
import ProfilePreferencesPage from './pages/ProfilePreferencesPage';
import ConfigurationPage from './pages/configuration/ConfigurationPage';
import UsersPageServer from 'src/pages/users/UsersPageServer';
import { V2Adapter } from 'src/v2/desktop/V2Adapter';
import { GenerateQuestionsPage } from 'src/v2/desktop/pages/GenerateQuestionsPage';
import { ReviewQuestionsPage } from 'src/v2/desktop/pages/ReviewQuestionsPage';
import { RequireAuditWhiz } from 'src/components/RequireAuditWhiz';
import { ROUTE_GENERATE_QUESTIONS, ROUTE_REVIEW_QUESTIONS } from 'src/v2/routes';
const AppRouter = () => {
  return (
    <Routes>
      <Route path={routes.HOME.path} element={<HomePage />} />
      <Route path={routes.DASHBOARDS.path} element={<HomePage />} />
      <Route path={routes.AUDITS.path} element={<AuditsPageGate />} />
      <Route path={routes.TASKS.path} element={<TasksPage />} />
      <Route path={routes.REPORTS.path} element={<ReportsPage />} />
      <Route path={routes.FEEDBACK.path} element={<FeedbackExportPage />} />
      <Route path={routes.TASK_DETAILS.path} element={<TaskDetailsPage />} />
      <Route path={routes.SETTINGS.path} element={<SettingsPage />} />
      <Route path={routes.CATEGORIES.path} element={<QuestionsCategoryPage />} />
      <Route path={routes.QUESTION.path} element={<QuestionPage />} />
      <Route
        path={ROUTE_GENERATE_QUESTIONS}
        element={
          <RequireAuditWhiz>
            <V2Adapter>
              <GenerateQuestionsPage />
            </V2Adapter>
          </RequireAuditWhiz>
        }
      />
      <Route
        path={ROUTE_REVIEW_QUESTIONS}
        element={
          <RequireAuditWhiz>
            <V2Adapter>
              <ReviewQuestionsPage />
            </V2Adapter>
          </RequireAuditWhiz>
        }
      />
      <Route path={routes.USERS.path} element={<UsersPage />} />
      <Route path={routes.USERS_SERVER.path} element={<UsersPageServer />} />
      <Route path={routes.NOTIFICATIONS.path} element={<NotificationsPage />} />
      <Route path={routes.LOCATIONS.path} element={<LocationsPage />} />
      <Route path={routes.TRANSLATIONS.path} element={<TranslationsPage />} />
      <Route path={routes.BUSINESS_UNITS_DIVISIONS.path} element={<TeamsPage />} />
      <Route path={routes.ROLES_PERMISSIONS.path} element={<PermissionsPage />} />
      <Route path={routes.TAGS.path} element={<TagsPage />} />
      <Route path={routes.TEMPLATE.path} element={<TemplatesPage />} />
      <Route path={routes.TEMPLATE_DETAILS.path} element={<TemplateDetailsPage />} />
      <Route path={routes.SCHEDULES.path} element={<SchedulesPage />} />
      <Route path={routes.SCHEDULE_DETAILS.path} element={<SchedulesDetailsPage />} />
      <Route path={routes.QUESTION_DETAILS.path} element={<QuestionDetailsPage />} />
      <Route path={routes.QUESTION_EDIT.path} element={<AddEditQuestionPage />} />
      <Route
        path={routes.QUESTION_TRANSLATION_EDIT.path}
        element={<TranslationEditPage />}
      />
      <Route path={routes.AUDIT_SUMMARY.path} element={<AuditSummaryPage />} />
      <Route path={routes.PERFORM_AUDIT.path} element={<PerformAuditPage />} />
      <Route path={routes.CONFIGURATION.path} element={<ConfigurationPage />} />
      <Route
        path={routes.PROFILE_PREFERENCES.path}
        element={<ProfilePreferencesPage />}
      />
    </Routes>
  );
};

export default AppRouter;
